import React from 'react';

export interface TecladoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const TecladoIcon: React.FC<TecladoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#a)"><path d="M23.011 7.854H3.959c-.77 0-1.395.585-1.395 1.308v8.64c0 .723.624 1.309 1.395 1.309h19.052c.77 0 1.396-.586 1.396-1.31V9.163c0-.723-.625-1.308-1.396-1.308M5.623 10.553h.915m2.763 0h.916m2.756 0h.916m2.756 0h.916m2.763 0h.915M5.623 13.481h.915m2.763 0h.916m2.756 0h.916m2.756 0h.916m2.763 0h.915M5.623 16.404h.915m3.763 0h6.26m3.763 0h.915"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.985.982h25v25h-25z"/></clipPath></defs>
    </svg>
  );
};

export default TecladoIcon;
